import { z } from 'zod';
import {
    type NodeSocketCfg,
    baseNodeCfgSchema,
} from './base-node';
import {
    type NodeCfg,
} from '../nodes';

export const functionalItem = z.object({
    dataType: z.union([ z.literal('string'), z.literal('number'), z.literal('boolean') ]),
    name: z.string(),
});
export interface FunctionalSelectItem extends z.infer<typeof functionalItem> {}

export const functionalSelectNodeCfgSchema = baseNodeCfgSchema.extend({
    kind: z.literal('functionalSelect'),
    controlValues: z.object({
        flowId: z.string(),
        inputs: z.array(functionalItem),
        outputs: z.array(functionalItem),
    }),
});
export type FunctionalSelectNodeCfgSchema = z.infer<typeof functionalSelectNodeCfgSchema>;

export const functionalSelectNodeSocketCfg = {
    controlSockets: {
        inputs: () => ({
            start: 'event',
        }),
        outputs: () => ({
            finish: 'event',
        }),
    },
    dataSockets: {
        inputs: (cfg: NodeCfg<'functionalSelect'>): Record<`input${number}`, 'string' | 'number' | 'boolean'> => {
            const inputs: Record<`input${number}`, 'string' | 'number' | 'boolean'> = {};
            cfg.controlValues.inputs.forEach((i, idx) => {
                inputs[`input${idx}`] = i.dataType;
            });
            return inputs;
        },
        outputs: (cfg: NodeCfg<'functionalSelect'>): Record<`output${number}`, 'string' | 'number' | 'boolean'> => {
            const outputs: Record<`output${number}`, 'string' | 'number' | 'boolean'> = {};
            cfg.controlValues.outputs.forEach((i, idx) => {
                outputs[`output${idx}`] = i.dataType;
            });
            return outputs;
        },
    },
} satisfies NodeSocketCfg<FunctionalSelectNodeCfgSchema>;
